import styled from 'styled-components';

export const UiTagFormPage = styled.div`
`;